import { useContext } from "react";
import { WidgetContext } from "src/providers/widget-provider";

export const useWidget = () => useContext(WidgetContext);
